package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.models.EntryState
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.px

@Composable
fun EntryAccordionContent(
    sectionId: String,
    cvViewModel: CvViewModel,
    onComplete: (String) -> Unit,
    onAddFormationAndClose: (String) -> Unit
) {
    val firstEntryId = "$sectionId-entry-1"

    var entries by remember {
        mutableStateOf(
            listOf(
                EntryState(
                    id = firstEntryId,
                    sectionId = sectionId
                )
            )
        )
    }

    var editingEntryId by remember {
        mutableStateOf<String?>(firstEntryId)
    }

    LaunchedEffect(sectionId) {
        if (
            cvViewModel.cvUiState.data.personalizedSections.none {
                it.id == firstEntryId
            }
        ) {
            cvViewModel.addEmptyPersonalizedEntry(firstEntryId)
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        entries.forEach { entry ->
            GenericFormCard(
                item = entry,
                isEditing = editingEntryId == entry.id,
                onEdit = {
                    editingEntryId = entry.id
                },
                onDelete = {
                    entries = entries.filterNot {
                        it.id == entry.id
                    }

                    cvViewModel.removePersonalizedSection(entry.id)

                    if (entries.isEmpty()) {
                        val newEntry = EntryState(
                            id = "entry-1",
                            sectionId = sectionId
                        )

                        entries = listOf(newEntry)
                        editingEntryId = newEntry.id
                    }
                },
                onComplete = {
                    saveEntry(entry, cvViewModel)
                    editingEntryId = null
                    onComplete(entry.id)
                },
                getSummary = { e ->
                    if (e.title.isNotBlank() || e.resume.isNotBlank()) {
                        SummaryData(
                            title = e.title.ifBlank { "[Titre]" },
                            subtitle = e.resume.ifBlank { "[Résumé]" }
                        )
                    } else {
                        null
                    }
                },
                getDefaultText = {
                    "[Entrée]"
                },
                formContent = { state, onDel, onComp ->
                    EntryForm(
                        state = state,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }

        AddButton(
            text = "Ajouter un élément",
            onClick = {
                val newEntry = EntryState(
                    id = "$sectionId-entry-${entries.size + 1}",
                    sectionId = sectionId
                )

                cvViewModel.addEmptyPersonalizedEntry(newEntry.id)

                entries = entries + newEntry
                editingEntryId = newEntry.id
            }
        )
    }
}

private fun saveEntry(
    entry: EntryState,
    cvViewModel: CvViewModel
) {
    cvViewModel.updatePersonalizedSection(
        sectionId = entry.id
    ) { section ->
        section.copy(
            title = entry.title,
            resume = entry.resume,
            started = "${entry.moisDebut} ${entry.anneeDebut}".trim(),
            ended = if (entry.isOngoing) {
                "Présent"
            } else {
                "${entry.moisFin} ${entry.anneeFin}".trim()
            },
            description = entry.description
        )
    }
}